<div class="dialog-header">
  <div class="dialog-icon-wrapper">
    <div class="dialog-icon new">
      <i class="fa-solid fa-flask"></i>
    </div>
    <div>
      <h2 class="dialog-title">Production Request Samples</h2>
      <p class="dialog-subtitle">Select sample details</p>
    </div>
  </div>
  <button class="dialog-close" (click)="onCancel()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  <form [formGroup]="sampleForm">
    <div class="table-container">
      <div class="data-card">
        <div class="table-wrapper">
          <table mat-table [dataSource]="tableDataSource" class="mat-mdc-table">

          <!-- Filename Column -->
          <ng-container matColumnDef="filename">
            <th mat-header-cell *matHeaderCellDef> Filename </th>
            <td mat-cell *matCellDef="let row" [formGroup]="row">{{row.get('fileName')?.value}}</td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef> Status </th>
            <td mat-cell *matCellDef="let row" [formGroup]="row">
              <mat-form-field appearance="outline" class="table-form-field">
                <mat-select formControlName="status"
                            placeholder="Select status"
                            [compareWith]="comparatorService.compareById">
                  @for(status of statuses; track status.id) {
                    <mat-option [value]="status">{{ status | objectdesc }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Actions </th>
            <td mat-cell *matCellDef="let row">
              <div class="actions">
                <button matButton class="act-btn" (click)="onDownloadSample(row)" matTooltip="Download Sample">
                  <i class="fa-solid fa-download"></i>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <button class="btn-ghost" (click)="onCancel()">Cancel</button>
  <button class="btn-blue" (click)="onSave()" [disabled]="!allowSave()">Save</button>
</mat-dialog-actions>
